export default "__VITE_ASSET__73nW4CAE__"